import answerService from "../../services/asnwerService/service";
import answerModel from "../../models/answerModel/model";
export default {
    async getAnswer(search, page, limit, company) {
        try{
            const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
            const { data, headers } = await answerService.getAnswer(sanitizedSearch, page, limit, company);
            return {
                data: data.map(answer => new answerModel(answer)),
                total: parseInt(headers['x-total-count'], 10), // Header untuk total data
            };
        } catch (error) {
            console.error(error);
        }
    },
    async totalAllAnswer(search, company){
        try{
            const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
            const { data } = await answerService.totalAllAnswer(sanitizedSearch, company);
            return data;
        } catch (error) {
            console.error(error);
        }
    },
    async addAnswer(answer) {
        try {
            return await answerService.addAnswer(answer);
        } catch (error) {
            console.error(error);
        }
    },
    async updateAnswer(answer) {
        try {
            return await answerService.updateAnswer(answer);
        } catch (error) {
            console.error(error);
        }
    },
    async deleteAnswer(id) {
        try {
            return await answerService.deleteAnswer(id);
        } catch (error) {
            console.error(error);
        }
    }
}

